
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AddAdministrativeCostsComments, DeleteAdministrativeCostsComments, GetAllAdministrativeCostsCommentsByStagesGuid, UpdateForShowHideAdministrativeCostsComments } from "../../Redux/Reducers/ReportStage/AdministrativeCostsComments"
import InputAHSF from "../../Components/InputAHSF"
import ButtonAHSF from "../../Components/ButtonAHSF"
import moment from "moment-timezone";

import './style.css'
const CommentPopup = (props) => {
    const dispatch = useDispatch()
    const [showActionAndInputComment, setShowActionAndInputComment] = useState(false)
    const userInfo = useSelector((state) => state.UserInfo.UserInfo)
    const allComment = useSelector((state) => state.AdministrativeCostsComments.AdministrativeCostsCommentsLists)
    const AddCommentRefresh = useSelector((state) => state.AdministrativeCostsComments.AddAdministrativeCostsComments)
    const DeleteCommentRefresh = useSelector((state) => state.AdministrativeCostsComments.DeleteAdministrativeCostsComments)
    const UpdateCommentRefresh = useSelector((state) => state.AdministrativeCostsComments.UpdateAdministrativeCostsComments)



    const [comment, setComment] = useState(null)
    console.log(allComment, "sdksdlskdlkwdw");
    const state = useSelector((state) => {
        return {
            jsonData: state.FetchDataJson.JsonData,
            ReportsStagesById: state.Stages.ReportsStagesById,
            RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
            ActiveRound: state.ApplicationInformation.ActiveRound,
            ApplicationInformation:
                state.ApplicationInformation.ApplicationInformation,
        };
    });
    useEffect(() => {
        dispatch(GetAllAdministrativeCostsCommentsByStagesGuid({
            pR_AdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId,
            pR_ReportsStagesGuid: props.stageGuid,

            employeeType: userInfo?.userToken?.userType
        }))
    }, [AddCommentRefresh, DeleteCommentRefresh, UpdateCommentRefresh])

    const AddComment = () => {
        dispatch(AddAdministrativeCostsComments({
            pR_EstimatedBudgetForAdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId,
            pR_ReportsStagesGuid: props.stageGuid,
            comment: comment,
            uS_UserGuid: userInfo?.userToken?.userGuid,
            canEdit: true
        }))
    }
    useEffect(() => {
        if (state.ReportsStagesById?.pR_StatusStagesGuid == "e8520232-873a-4237-aac2-9520f3e55f24" && (state.RoleByUserGuid?.includes("f8decae8-ba89-484c-94f6-22c64996266a") || state.RoleByUserGuid?.includes("45ab458b-7479-4b83-bf88-49a9cd65226d"))) {
            setShowActionAndInputComment(true)
        }
    }, [state.ReportsStagesById?.pR_StatusStagesGuid, state.RoleByUserGuid])



    const DeleteComment = (id) => {
        dispatch(DeleteAdministrativeCostsComments({ pR_DistributionAdministrativeCostsCommentsGUID: id }))
    }


    const ShowHideAdministrativeCostsComments = (id) => {
        dispatch(UpdateForShowHideAdministrativeCostsComments({ pR_DistributionAdministrativeCostsCommentsGUID: id }))
    }

    return (
        <>
            {
                allComment ? <div className="containerCommentPopup">
                    <div className="">

                        <div>
                            {
                                allComment && allComment.map((ele, ind) => {
                                    console.log(ele, "sdsssss");

                                    return (
                                        <div className="containerComment">
                                            <div className="containerCommentAndDate">
                                                <div>
                                                    <p>
                                                        {
                                                            ele.
                                                                comment
                                                        }
                                                    </p>
                                                </div>
                                                <div className="NameAndDate">
                                                    <div className="NameUser">
                                                        {
                                                            ele.uS_User.firstName + " " + ele.uS_User.lastName

                                                        }
                                                    </div>
                                                    <div className="DateCommint">
                                                        {
                                                            moment(ele.dateCreate).format(
                                                                "dd/MM/yyyy"
                                                            )


                                                        }
                                                    </div>
                                                </div>
                                            </div>


                                            {
                                                ele.uS_UserGuid == userInfo?.userToken?.userGuid ? <div className="containerAction">
                                                    <div onClick={() => {
                                                        ShowHideAdministrativeCostsComments(ele?.pR_DistributionAdministrativeCostsCommentsGUID)
                                                    }}>

                                                        {ele.showSubmitter == false ? (
                                                            <div>
                                                                <i class="bi bi-eye-slash"></i>
                                                            </div>
                                                        ) : (
                                                            <div>
                                                                <i class="bi bi-eye"></i>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div onClick={() => {
                                                        DeleteComment(ele?.pR_DistributionAdministrativeCostsCommentsGUID)
                                                    }} className="">
                                                        <i class="bi bi-trash3-fill"></i>
                                                    </div>
                                                </div> : <></>
                                            }


                                        </div>)
                                })
                            }
                        </div>

                        {
                            showActionAndInputComment ? <>
                                <div >
                                    <InputAHSF
                                        fieldsName="CommentInput"
                                        show={true}
                                        disabled={props.disabledData ? true : false}
                                        defaultValue={
                                            ""
                                        }
                                        onChange={(e) => {
                                            setComment(e.target.value);
                                        }}
                                        showValidationMessage={false}
                                        validationMessage={"حقل اجباري"}
                                    />
                                </div>

                                <div className="containerButton">
                                    <ButtonAHSF
                                        onClick={
                                            AddComment
                                        }
                                        text={"حفظ"}
                                        show={true}
                                    />
                                </div>
                            </> : <></>
                        }

                    </div>


                </div> : <></>
            }
        </>
    )
}

export default CommentPopup